import { FormControl } from '@mui/material'
import { DateTimePicker, DateTimePickerProps, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { C1FormLabel } from 'components/core/RHKFormComponents/C1FormLabel'
import { FC } from 'react'

export const C1DateTimePicker: FC<DateTimePickerProps<Date>> = ({
    label,
    ...props
}) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <FormControl>
                <C1FormLabel label={label} />
                <DateTimePicker
                    reduceAnimations
                    minutesStep={5}
                    slotProps={{
                        textField: { size: 'small' },
                        digitalClockSectionItem: {
                            sx: { borderRadius: C1BorderRadius.regular, py: 1 },
                        },
                    }}
                    {...props}
                />
            </FormControl>
        </LocalizationProvider>
    )
}
